// extracted by mini-css-extract-plugin
module.exports = {"jcInformational100":"#c3d8ff","nav":"ImportUsersResultsNav__nav","card":"ImportUsersResultsNav__card"};